import {combineReducers} from 'redux'

import {pages} from './pages'

export const reducers = combineReducers({ pages })